<script lang="ts">
  import EventAppBar from "../../../components/events/event-app-bar.svelte";
  import EventProfile from "../../../components/events/profile.svelte";
  import { getNow, getTimeZone } from "../../../data/clock";
  import { getWeeklySchedule } from "../../../domain/events";
  import { find } from "lodash-es";

  export let data;

  $: time = getNow();
  $: timeZone = getTimeZone();
  $: event = data.event;
  $: places = data.places;
  $: map = data.map;
  $: schedule = getWeeklySchedule(event, $time, $timeZone).map((entry) => {
    return {
      ...entry,
      event: event,
      place: find(places, { id: entry.placeId })
    };
  });
</script>

<EventAppBar {event} {map} {places} {schedule} {time} {timeZone} />

<EventProfile {event} {schedule} {time} {timeZone} />
